module.exports = __webpack_public_path__ + "static/media/card.25042980.png";